import { is } from 'stdlib/is'

/**
 * Event(ek) eltávolítása.
 * @param elOrQuery  - Maga az elem, vagy query ami alapján elkérjük az elemet.
 * @param ev         - Event(ek).
 * @param func       - Callback, eseménynél futott meg.
 * @param useCapture - Azt a fázist jelöli ki, amikor az eseményt kezelni szeretnénk (pl. Bubbling).
 */
export default function off ( // eslint-disable-line @typescript-eslint/max-params -- Legacy.
  elOrQuery: HTMLElement | string,
  ev: string,
  func: EventListenerOrEventListenerObject,
  useCapture = false
): void {
  const events = ev.trim().split(/\s+/)

  const el = is.string(elOrQuery) ? document.querySelector(elOrQuery) : elOrQuery

  events.forEach((event) => {
    el?.removeEventListener(event, func, useCapture)
  })
}
